import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { BasketUpsellComboFormCTX } from '@basket/types/BasketUpsellComboFormContext';
import { useCallback, useState } from 'react';
import { useContext } from 'preact/compat';
import MiscFormWrapper from '@widgets/UpsellModal/components/ComboForm/MiscFormWrapper';
import BookingForm from '@widgets/UpsellModal/components/ComboForm/BookingForm';
import { useUpsellModal } from '@widgets/UpsellModal/UpsellModal';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import LoadingSpinner from '@widgets/shared/components/LoadingSpinner';
function ComboForm({ onComplete }) {
    const [showBookingForm, setShowBookingForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [miscPromises, setMiscPromises] = useState([]);
    const { setBackgroundVisible, setContentVisible, handleModalClose } = useUpsellModal();
    const options = useContext(BasketUpsellComboFormCTX);
    const handleMiscFormComplete = useCallback(() => {
        setShowBookingForm(true);
        setContentVisible(false);
        setBackgroundVisible(false);
    }, [setBackgroundVisible, setContentVisible]);
    const handleBookingFormComplete = useCallback(() => {
        setLoading(true);
        Promise.all(miscPromises.map((fn) => fn()))
            .then((res) => {
            const lastRes = res.at(-1);
            if (lastRes) {
                onComplete();
            }
        })
            .finally(() => {
            setLoading(false);
            handleModalClose();
        });
    }, [handleModalClose, miscPromises, onComplete]);
    const onUpsellClose = useGlobalEvent('upsell.close');
    onUpsellClose(() => {
        setShowBookingForm(false);
    });
    return (_jsxs(_Fragment, { children: [loading && (_jsx(LoadingSpinner, { colourOverride: "#00AEEF" })), (!loading && !showBookingForm) && (_jsx(MiscFormWrapper, { onComplete: (promises) => {
                    setMiscPromises(promises);
                    handleMiscFormComplete();
                } })), (!loading && showBookingForm) && (_jsx(BookingForm, { onComplete: handleBookingFormComplete }))] }));
}
export default ComboForm;
